import cookieService from "./cookie.service";
import CookieService from "@/core/cookie.service";

declare let window: IWindow;

export enum SiteMode {
    Professional = "professional",
    Private = "private",
}

class ServerContextService {
    get version() {
        return window._app.serverContext.version;
    }

    get statusCode() {
        return window._app.serverContext.statusCode;
    }

    get spaMode() {
        return window._app.serverContext.spaMode || false;
    }

    get initialBreadcrumb() {
        return window._app.serverContext.initialBreadcrumb || [];
    }

    get usp() {
        return window._app.siteModeContext.usp || null;
    }

    get footer() {
        return window._app.siteModeContext.footer || null;
    }

    get recaptchaKey() {
        return window._app.serverContext.recaptchaKey || "";
    }

    get menu() {
        return window._app.userContext.menu || [];
    }

    get myAccountRoot() {
        return window._app.userContext.myAccountRoot || null;
    }

    get portalRoot() {
        return window._app.userContext.portalRoot || null;
    }

    get languages() {
        return window._app.siteModeContext.languages || [];
    }

    get primaryCountryCode() {
        return window._app.serverContext.primaryCountryCode || "";
    }

    get modes() {
        // set selected mode from client side via cookie value
        const modes = window._app.serverContext.modes || [];
        const selectedMode = CookieService.getSiteMode();
        if (selectedMode) {
            modes.forEach((mode) => {
                mode.isSelected = mode.name.toLowerCase() === selectedMode.toLowerCase();
            });
        } else {
            // if no cookie, set first mode as selected
            if (modes.length > 0) {
                modes[0].isSelected = true;
            }
        }
        return modes;
    }

    get isPrivateMode() {
        return CookieService.getSiteMode().toLowerCase() === SiteMode.Private;
        // const modes = window._app.serverContext.modes || [];
        // const selectedMode = modes.find(x => x.isSelected) || {} as any;
        // return selectedMode.id === 0;
    }

    get isAuthenticated() {
        return window._app.userContext.isAuthenticated || false;
    }

    get displayNameB2B() {
        return window._app.userContext.displayNameB2B || "";
    }

    get isBasketVisible() {
        return window._app.userContext.isBasketVisible || false;
    }

    get isQuoteBasketVisible() {
        return window._app.userContext.isQuoteBasketVisible || false;
    }

    get hideSiteModeProf() {
        return window._app.serverContext.hideSiteModeProf || false;
    }

    get isCheckoutView() {
        return window._app.serverContext.isCheckoutView || false;
    }

    get isCheckoutViewWithTopBar() {
        return window._app.serverContext.isCheckoutViewWithTopBar || false;
    }

    get hideNavigationSpacer() {
        return window._app.serverContext.hideNavigationSpacer || false;
    }

    get hideBreadcrumb() {
        return window._app.serverContext.hideBreadcrumb || false;
    }

    get previousUrlBreadcrumb() {
        return window._app.serverContext.previousUrlBreadcrumb || false;
    }

    get pages() {
        return window._app.serverContext.pages;
    }

    get dateFormat() {
        return window._app.serverContext.dateFormat;
    }

    get twoLetterISOLanguageName() {
        return window._app.serverContext.twoLetterISOLanguageName;
    }

    get languageName() {
        return window._app.serverContext.languageName;
    }

    get currencyName() {
        return window._app.serverContext.currencyName;
    }

    get alternateMarketData() {
        return window._app.serverContext.alternateMarketData;
    }

    get pointOfSale() {
        return window._app.userContext.pointOfSale;
    }

    get initialHideB2BPricesState() {
        return window._app.userContext.initialHideB2BPricesState;
    }

    get showNewsletterPopup() {
        return (
            (window._app.serverContext.showNewsletterPopupPrivate && this.isPrivateMode) ||
            (window._app.serverContext.showNewsletterPopupProfessional && !this.isPrivateMode)
        );
    }

    get showSignUpDiscountPopup() {
        return window._app.userContext.showSignUpDiscountPopup && this.isPrivateMode;
    }

    get signUpDiscountPopupImageUrl() {
        return window._app.userContext.signUpDiscountPopupImageUrl;
    }

    get cordCuttingLinkUrl() {
        return window._app.serverContext.cordCuttingLinkUrl;
    }

    get theme() {
        return window._app.serverContext.theme;
    }

    get menuTheme() {
        return window._app.serverContext.menuTheme;
    }

    get showStockB2B() {
        return window._app.serverContext.showStockB2B;
    }

    get salesConsultantB2B() {
        return window._app.userContext.salesConsultantB2B;
    }
}

export default new ServerContextService();
